import React, {useRef, useState} from "react"
import {Col, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";


// component
import CategoryForm from "./_categoryForm";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {GenericButton} from "../../../../components/buttons/customButtons";

// services
import {categoryUdnService} from "../../../../jwt/_services/park/DynamicModuleService";

// providers
import {categoryProvider} from "../../../../providers/categoryProvider";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";






const AddCategoryComponent = props => {
    const {mainPath, categoriesPath} = props
    const udnState = useSelector(state => getStateByPath(state, mainPath));
    const categoriesState = useSelector(state => getStateByPath(state, categoriesPath));

    const { domainObject:udn, app:{ fbDataBase } } = udnState?.data || {};
    const { listDomainObjects:categories } = categoriesState?.data || {};

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryIsLinked, setCategoryIsLinked] = useState(false);
    const [loading, setLoading] = useState(false);

    const categoryFormModalRef = useRef(null);
    

    const onSelectCategory = categoryId => {
        const isCategoryLinked = categories?.some(({category}) => category?.id === categoryId);
        setCategoryIsLinked(isCategoryLinked);


        if(isCategoryLinked) return;

        setSelectedCategory(categoryId);
    }




    const onLinkCategory = () => {
        if(categoryIsLinked) return

        setLoading(true);

        const requestData = {
            fbDataBase: { id: fbDataBase?.id },
            item: {
                udn: { id: udn?.id },
                category: { id: selectedCategory },
            }
        }

        genericIndexedActions.save(categoriesPath, categoryUdnService, requestData, onFinishLinkCategory)
    }



    const onFinishLinkCategory = () => {
        setSelectedCategory(null)
        setLoading(false);
    }




    const createCategory = () => {
        props.setItem(categoriesPath, null);
        props.setForm(categoriesPath);

        categoryFormModalRef.current.showModal();
    }





    
    return <>
        <div className="bg-light border-bottom p-3 mb-2em">
            Categorías
            <div className="float-right" style={{marginTop: "-10px"}}>
                <GenericButton
                    style={'success-secondary'}
                    label={'Crear y Vincular Catagoría'}
                    toolTip={'Nueva Categoría'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createCategory}
                />
            </div>
        </div>

        <Row>
            <Col sm={9}>
                <SelectGeneric
                    title={"Vincular la categoría:"}
                    placeholder={"Seleccione una categoría"}
                    provider={categoryProvider}
                    initialValue={selectedCategory}
                    setExternalValue={onSelectCategory}
                    hasError={categoryIsLinked}
                    errorMessage={categoryIsLinked ? 'La categoría asignada ya esta vinculada con la unidad de negocio' : ''}
                />
            </Col>
            <Col style={{paddingTop: '20px'}}>
                <GenericButton
                    style={'table'}
                    label={'Vincular'}
                    toolTip={'Vincular Categoría'}
                    icon={'fa-link'}
                    permission={'add'}
                    loading={loading}
                    disabled={!selectedCategory || categoryIsLinked || loading}
                    onClick={onLinkCategory}
                />
            </Col>
        </Row>

        <CategoryForm
            ref={categoryFormModalRef}
            mainPath={mainPath}
            categoriesPath={categoriesPath}
        />
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setForm,
    setItem,
})


export default connect(mapStateToProps, mapActionsToProps)(AddCategoryComponent);